import { InjectionToken } from '@angular/core';
import type { BlogPost } from './blog-types';
import { POSTS } from './posts.generated';

/**
 * The full blog corpus — the build-time generated array of BlogPost objects
 * produced by `scripts/build-blog.mts` from `src/content/blog/*.md`.
 *
 * Injected rather than imported directly so tests can substitute a controlled
 * fixture via `provideBlogPosts([...])`.
 */
export const BLOG_POSTS = new InjectionToken<readonly BlogPost[]>(
  'BLOG_POSTS',
  {
    providedIn: 'root',
    factory: () => POSTS,
  },
);

export function provideBlogPosts(posts: readonly BlogPost[]): {
  provide: typeof BLOG_POSTS;
  useValue: readonly BlogPost[];
} {
  return { provide: BLOG_POSTS, useValue: posts };
}
